
// import React, { useState } from "react";
// import styles from "../../assets/scss/Dashboard.module.scss";
// import {
//   FiBox,
//   FiTruck,
//   FiClock,
// } from "react-icons/fi";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
// } from "chart.js";
// import GaugeChart from "react-gauge-chart";
// import Slider from "react-slick"; // ✅ Import for banner carousel
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import { useNavigate } from "react-router-dom";
// import { useGetDashboardQuery } from "../../slices/admin/admin";
// import { BaseURL } from "../../lib/api";
// import dummyProfile from "../../assets/images/Profile.png";

// ChartJS.register(
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement
// );

// const FarmerDashboard = () => {
//   const navigate = useNavigate();
//   const { data, isLoading } = useGetDashboardQuery();

//   const dashboard = data?.data || {};
//   const bannerImages = dashboard.bannerImages || []; // ✅ Fixed undefined variable

//   const [tooltip, setTooltip] = useState({
//     show: false,
//     text: "",
//     x: 0,
//     y: 0,
//   });

//   const totalPayableCredit = dashboard.totalAmountPending || 0;
//   const totalReceivableCredit = dashboard.totalAmountReceived || 0;
//   const total = totalPayableCredit + totalReceivableCredit;

//   const receivableRatio = total === 0 ? 0.5 : totalReceivableCredit / total;
//   const payableRatio = total === 0 ? 0.5 : totalPayableCredit / total;

//   const handleMouseEnter = (e, type) => {
//     const rect = e.target.getBoundingClientRect();
//     setTooltip({
//       show: true,
//       text:
//         type === "payable"
//           ? `Payable: ₹${totalPayableCredit}`
//           : `Receivable: ₹${totalReceivableCredit}`,
//       x: rect.left + rect.width / 2,
//       y: rect.top - 10,
//     });
//   };

//   const handleMouseLeave = () => {
//     setTooltip({ show: false, text: "", x: 0, y: 0 });
//   };

//   // ✅ Added Slider configuration
//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 800,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3500,
//     arrows: false,
//   };

//   if (isLoading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className={styles.dashboard}>
//       <div className={styles.grid}>
//         {/* Invoice Overview */}
//         <div className={styles.card}>
//           <div className={styles.header}>
//             <h4 className={styles.heading}>Invoice Overview</h4>
//             <span onClick={() => navigate("/dashboard/Invoicetable")}>
//               View all
//             </span>
//           </div>
//           <div className={styles.overviewGridfarmer}>
//             <div className={`${styles.box} ${styles.orange}`}>
//               <FiBox className={styles.icon} />
//               <h3>{dashboard.totalMyInvoices || 0}</h3>
//               <p>My Invoices</p>
//             </div>
//             <div className={`${styles.box} ${styles.purple}`}>
//               <FiTruck className={styles.icon} />
//               <h3>{dashboard.totalmyPendingInvoice || 0}</h3>
//               <p>Pending Invoice</p>
//             </div>
//           </div>
//         </div>

//         {/* ✅ Banner Section */}
//         <div className={styles.card}>
//           <div className={styles.header}>
//             <h4 className={styles.heading}>Banner</h4>
//           </div>
//           <div className={styles.bannerSliderWrapper}>
//             {bannerImages && bannerImages.length > 0 ? (
//               <Slider {...sliderSettings}>
//                 {bannerImages.map((img, idx) => (
//                   <div key={idx} className={styles.bannerSlide}>
//                     <img
//                       src={`${BaseURL}/${img}`}
//                       alt={`banner-${idx}`}
//                       className={styles.bannerimg}
//                     />
//                   </div>
//                 ))}
//               </Slider>
//             ) : (
//               <p>No banner images available</p>
//             )}
//           </div>
//         </div>

//         {/* Sales Overview Gauge */}
//         <div className={styles.card}>
//           <div className={styles.header}>
//             <h4 className={styles.heading}>Sales Overview</h4>
//             <span onClick={() => navigate("/dashboard/billing")}>View all</span>
//           </div>

//           <div
//             style={{
//               width: "100%",
//               maxWidth: 400,
//               margin: "0 auto",
//               position: "relative",
//             }}
//           >
//             <GaugeChart
//               id="credit-balance-meter"
//               nrOfLevels={20}
//               arcsLength={[payableRatio, receivableRatio]}
//               colors={["#bfb8da", "#e8b7d4"]}
//               percent={receivableRatio}
//               arcPadding={0.02}
//               needleColor="#222"
//               needleBaseColor="#888"
//               textColor="#000"
//               formatTextValue={() => ""}
//             />

//             <div
//               style={{
//                 position: "absolute",
//                 top: "20%",
//                 left: "10%",
//                 width: "35%",
//                 height: "60%",
//                 cursor: "pointer",
//               }}
//               onMouseEnter={(e) => handleMouseEnter(e, "payable")}
//               onMouseLeave={handleMouseLeave}
//             />
//             <div
//               style={{
//                 position: "absolute",
//                 top: "20%",
//                 right: "10%",
//                 width: "35%",
//                 height: "60%",
//                 cursor: "pointer",
//               }}
//               onMouseEnter={(e) => handleMouseEnter(e, "receivable")}
//               onMouseLeave={handleMouseLeave}
//             />

//             {tooltip.show && (
//               <div
//                 style={{
//                   position: "fixed",
//                   top: tooltip.y,
//                   left: tooltip.x,
//                   transform: "translate(-50%, -100%)",
//                   background: "#333",
//                   color: "#fff",
//                   padding: "5px 10px",
//                   borderRadius: "6px",
//                   fontSize: "12px",
//                   whiteSpace: "nowrap",
//                   zIndex: 1000,
//                 }}
//               >
//                 {tooltip.text}
//               </div>
//             )}

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginTop: 10,
//               }}
//             >
//               <span style={{ color: "black", fontSize: "10px", fontWeight: "bold" }}>
//                 Total Payable Amount: ₹ {totalPayableCredit}
//               </span>
//               <span style={{ color: "black", fontSize: "10px", fontWeight: "bold" }}>
//                 Total Receivable Amount: ₹ {totalReceivableCredit}
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Notifications Section */}
//       <div className={styles.gridsemp}>
//         <div className={styles.card}>
//           <div className={styles.header}>
//             <h4 className={styles.heading}>Notifications</h4>
//             <span onClick={() => navigate("/dashboard/Notifications")}>
//               View all
//             </span>
//           </div>

//           <div className={styles.notificationsfarmerbanner}>
//             {dashboard.notifications?.slice(0, 10).map((note) => (
//               <div
//                 key={note._id}
//                 className={`${styles.notification} ${note.isRead === false ? styles.unreadNotification : ""
//                   }`}
//               >
//                 <img
//                   src={
//                     note.createdBy?.profile
//                       ? `${BaseURL}/${note.createdBy?.profile}`
//                       : dummyProfile
//                   }
//                   alt={note.createdBy?.name || "User"}
//                 />
//                 <div>
//                   <p>{note.message}</p>
//                   <span
//                     className={note.isRead === false ? styles.redText : ""}
//                   >
//                     <FiClock
//                       className={note.isRead === false ? styles.redIcon : ""}
//                     />{" "}
//                     {new Date(note.createdAt).toLocaleDateString("en-GB")}
//                   </span>
//                 </div>
//               </div>
//             ))}
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default FarmerDashboard;

import React, { useState } from "react";
import styles from "../../assets/scss/Dashboard.module.scss";
import {
  FiBox,
  FiTruck,
  FiClock,
} from "react-icons/fi";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
} from "chart.js";
import GaugeChart from "react-gauge-chart";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useNavigate } from "react-router-dom";
import { useGetDashboardQuery } from "../../slices/admin/admin";
import { BaseURL } from "../../lib/api";
import dummyProfile from "../../assets/images/Profile.png";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement
);

const FarmerDashboard = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useGetDashboardQuery();

  const dashboard = data?.data || {};
  const bannerImages = dashboard.bannerImages || [];

  const [tooltip, setTooltip] = useState({
    show: false,
    text: "",
    x: 0,
    y: 0,
  });

  const totalPayableCredit = dashboard.totalAmountPending || 0;
  const totalReceivableCredit = dashboard.totalAmountReceived || 0;
  const total = totalPayableCredit + totalReceivableCredit;

  const receivableRatio = total === 0 ? 0.5 : totalReceivableCredit / total;
  const payableRatio = total === 0 ? 0.5 : totalPayableCredit / total;

  // ✅ Utility: Handle S3 and local URLs safely cleanly
  const resolveImageUrl = (path, fallback = dummyProfile) => {
    if (!path) return fallback;
    if (typeof path !== "string") return fallback;
    if (path.startsWith("http")) return path;
    const cleanPath = path.replace(/^\/+/, "");
    const cleanBaseURL = BaseURL.replace(/\/+$/, "");
    return `${cleanBaseURL}/${cleanPath}`;
  };

  const handleMouseEnter = (e, type) => {
    const rect = e.target.getBoundingClientRect();
    setTooltip({
      show: true,
      text:
        type === "payable"
          ? `Payable: ₹${totalPayableCredit}`
          : `Receivable: ₹${totalReceivableCredit}`,
      x: rect.left + rect.width / 2,
      y: rect.top - 10,
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ show: false, text: "", x: 0, y: 0 });
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className={styles.dashboard}>
      <div className={styles.grid}>
        {/* Invoice Overview */}
        <div className={styles.card}>
          <div className={styles.header}>
            <h4 className={styles.heading}>Invoice Overview</h4>
            <span onClick={() => navigate("/dashboard/Invoicetable")}>
              View all
            </span>
          </div>
          <div className={styles.overviewGridfarmer}>
            <div className={`${styles.box} ${styles.orange}`}>
              <FiBox className={styles.icon} />
              <h3>{dashboard.totalMyInvoices || 0}</h3>
              <p>My Invoices</p>
            </div>
            <div className={`${styles.box} ${styles.purple}`}>
              <FiTruck className={styles.icon} />
              <h3>{dashboard.totalmyPendingInvoice || 0}</h3>
              <p>Pending Invoice</p>
            </div>
          </div>
        </div>

        {/* ✅ Banner Section */}
        <div className={styles.bannerCard}>
          <div className={styles.header}>
            <h4 className={styles.heading}>Banner</h4>
           
          </div>
          <div className={styles.bannerSliderWrapper}>
            {bannerImages && bannerImages.length > 0 ? (
              <Slider {...sliderSettings}>
                {bannerImages.map((img, idx) => (
                  <div key={idx} className={styles.bannerSlide}>
                    <img
                      src={resolveImageUrl(img)}
                      alt={`banner-${idx}`}
                      className={styles.bannerimg}
                      onError={(e) => { e.target.onerror = null; e.target.src = dummyProfile; }}
                    />
                  </div>
                ))}
              </Slider>
            ) : (
              <p>No banner images available</p>
            )}
          </div>
        </div>

        {/* Sales Overview Gauge */}
        <div className={styles.card}>
          <div className={styles.header}>
            <h4 className={styles.heading}>Sales Overview</h4>
            <span onClick={() => navigate("/dashboard/billing")}>View all</span>
          </div>

          <div
            style={{
              width: "100%",
              maxWidth: 400,
              margin: "0 auto",
              position: "relative",
            }}
          >
            <GaugeChart
              id="credit-balance-meter"
              nrOfLevels={20}
              arcsLength={[payableRatio, receivableRatio]}
              colors={["#bfb8da", "#e8b7d4"]}
              percent={receivableRatio}
              arcPadding={0.02}
              needleColor="#222"
              needleBaseColor="#888"
              textColor="#000"
              formatTextValue={() => ""}
            />

            <div
              style={{
                position: "absolute",
                top: "20%",
                left: "10%",
                width: "35%",
                height: "60%",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => handleMouseEnter(e, "payable")}
              onMouseLeave={handleMouseLeave}
            />
            <div
              style={{
                position: "absolute",
                top: "20%",
                right: "10%",
                width: "35%",
                height: "60%",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => handleMouseEnter(e, "receivable")}
              onMouseLeave={handleMouseLeave}
            />

            {tooltip.show && (
              <div
                style={{
                  position: "fixed",
                  top: tooltip.y,
                  left: tooltip.x,
                  transform: "translate(-50%, -100%)",
                  background: "#333",
                  color: "#fff",
                  padding: "5px 10px",
                  borderRadius: "6px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  zIndex: 1000,
                }}
              >
                {tooltip.text}
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 10,
              }}
            >
              <span
                style={{ color: "black", fontSize: "10px", fontWeight: "bold" }}
              >
                Total Payable Amount: ₹ {totalPayableCredit}
              </span>
              <span
                style={{ color: "black", fontSize: "10px", fontWeight: "bold" }}
              >
                Total Receivable Amount: ₹ {totalReceivableCredit}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Notifications Section */}
      <div className={styles.gridsemp}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h4 className={styles.heading}>Notifications</h4>
            <span onClick={() => navigate("/dashboard/Notifications")}>
              View all
            </span>
          </div>

          <div className={styles.notificationsfarmerbanner}>
            {dashboard.notifications?.slice(0, 10).map((note) => (
              <div
                key={note._id}
                className={`${styles.notification} ${note.isRead === false ? styles.unreadNotification : ""
                  }`}
              >
                <img
                  src={resolveImageUrl(note.createdBy?.profile)}
                  alt={note.createdBy?.name || "User"}
                />
                <div>
                  <p>{note.message}</p>
                  <span
                    className={note.isRead === false ? styles.redText : ""}
                  >
                    <FiClock
                      className={note.isRead === false ? styles.redIcon : ""}
                    />{" "}
                    {new Date(note.createdAt).toLocaleDateString("en-GB")}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmerDashboard;
